import React, { useState } from 'react';
import styles from './Carousel.module.scss';
import './Carousel.css'
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import { NextArrow } from './featured/NextArrow';
import { PreviewArrow } from './featured/PreviewArrow';



export default function Carousel(props) {
  const [arrowLocation, setArrowLocation] = useState(props.arrow);
  
    var settings = {
        infinite: false,
        speed: 500,
        slidesToShow: props.desktopSlidesToShow ? props.desktopSlidesToShow : 4,
        slidesToScroll: 1 ,
        initialSlide: 0,
        nextArrow: arrowLocation == "top" ? <NextArrow arrowLocation={arrowLocation} /> : <NextArrow />,
        prevArrow: arrowLocation == "top" ? <PreviewArrow arrowLocation={arrowLocation} /> : <PreviewArrow />,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: props.tabletSlidesToShow ? props.tabletSlidesToShow : 3,
              slidesToScroll: 1,
              dots: true,
              dotsClass:'slick-dots customDot mb-3',
              arrows: false
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: props.mobileSlidesToShow ? props.mobileSlidesToShow : 2,
              slidesToScroll: 2,
              initialSlide: 2,
              dots: true,
              dotsClass:'slick-dots customDot mb-3',
              arrows: false
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: props.mobileSlidesToShow ? props.mobileSlidesToShow : 1,
              slidesToScroll: 1,
              dots: true,
              dotsClass:' ',
              dotsClass:'slick-dots customDot mb-3',
              arrows: false
            }
          }
        ]
      };
  return (
    <carousel-component>
        <Slider {...settings} className={`${styles.carousel} ${props.align == 'left' && 'align-left'}`}>
            {props.children}
        </Slider>
    </carousel-component>
  )
}
